/* eslint-disable */
// inferenceai-api v0.1.0 00cf6697ea6bb7ee379312cc75a80111c58ea996
// --
// Code generated by webrpc-gen@v0.26.0 with typescript@v0.17.0 generator. DO NOT EDIT.
//
// webrpc-gen -schema=proto/inference.ridl -target=typescript@v0.17.0 -client -out=./clients/inference.gen.ts

export const WebrpcHeader = "Webrpc"

export const WebrpcHeaderValue = "webrpc@v0.26.0;gen-typescript@v0.17.0;inferenceai-api@v0.1.0"

// WebRPC description and code-gen version
export const WebRPCVersion = "v1"

// Schema version of your RIDL schema
export const WebRPCSchemaVersion = "v0.1.0"

// Schema hash generated from your RIDL schema
export const WebRPCSchemaHash = "00cf6697ea6bb7ee379312cc75a80111c58ea996"

type WebrpcGenVersions = {
  webrpcGenVersion: string;
  codeGenName: string;
  codeGenVersion: string;
  schemaName: string;
  schemaVersion: string;
};

export function VersionFromHeader(headers: Headers): WebrpcGenVersions {
  const headerValue = headers.get(WebrpcHeader);
  if (!headerValue) {
    return {
      webrpcGenVersion: "",
      codeGenName: "",
      codeGenVersion: "",
      schemaName: "",
      schemaVersion: "",
    };
  }

  return parseWebrpcGenVersions(headerValue);
}

function parseWebrpcGenVersions(header: string): WebrpcGenVersions {
  const versions = header.split(";");
  if (versions.length < 3) {
    return {
      webrpcGenVersion: "",
      codeGenName: "",
      codeGenVersion: "",
      schemaName: "",
      schemaVersion: "",
    };
  }

  const [_, webrpcGenVersion] = versions[0]!.split("@");
  const [codeGenName, codeGenVersion] = versions[1]!.split("@");
  const [schemaName, schemaVersion] = versions[2]!.split("@");

  return {
    webrpcGenVersion: webrpcGenVersion ?? "",
    codeGenName: codeGenName ?? "",
    codeGenVersion: codeGenVersion ?? "",
    schemaName: schemaName ?? "",
    schemaVersion: schemaVersion ?? "",
  };
}

//
// Types
//


export enum RoleID {
  Admin = 'Admin',
  User = 'User',
  Manager = 'Manager'
}

export enum OnLimitReachedOperation {
}

export enum ServerTemplateType {
  vllm = 'vllm',
  custom = 'custom',
  sglang = 'sglang'
}

export enum AuditLogType {
  server_create = 'server_create',
  server_delete = 'server_delete',
  storage_create = 'storage_create',
  storage_delete = 'storage_delete',
  user_delete = 'user_delete',
  user_role_update = 'user_role_update',
  user_invite = 'user_invite',
  user_accept_invite = 'user_accept_invite',
  create_org_spending_limit = 'create_org_spending_limit',
  create_org_user_spending_limit = 'create_org_user_spending_limit',
  update_org_limit = 'update_org_limit',
  update_org_user_limit = 'update_org_user_limit'
}

export enum CreditHistoryRecordType {
  server_template_cost = 'server_template_cost',
  storage_cost = 'storage_cost',
  resource_fake_cost = 'resource_fake_cost',
  system_add = 'system_add',
  org_add = 'org_add',
  user_add = 'user_add',
  system_org_deduct = 'system_org_deduct',
  system_user_deduct = 'system_user_deduct'
}

export enum InvoiceType {
  org_credit = 'org_credit',
  user_credit = 'user_credit'
}

export enum KubeType {
  qudong = 'qudong',
  virtualization = 'virtualization'
}

export enum NotificationType {
  spending_limit = 'spending_limit',
  user_spending_limit = 'user_spending_limit',
  add_user_credit = 'add_user_credit',
  add_org_credit = 'add_org_credit',
  shutdown_user_resource = 'shutdown_user_resource',
  server_capacity_exceeded = 'server_capacity_exceeded',
  server_failure = 'server_failure',
  ephemeral_storage_alert = 'ephemeral_storage_alert',
  server_oom = 'server_oom'
}

export enum OnLimitReached {
  notification = 'notification',
  shutdown = 'shutdown'
}

export enum StorageVolumeStatus {
  unmounted = 'unmounted',
  mounted = 'mounted'
}

export interface Time {
}

export interface Role {
  role_id: number
  role_name: string
  description: string
  created_at: string
  updated_at: string
}

export interface UserLimit {
  org_per_user_storage_gb: number
  org_per_user_storage_total_gb: number
  org_per_user_storage_count: number
  org_per_user_server_count: number
}

export interface OrganizationMetadataLimit {
  org_total_storage_gb: number
  org_total_active_server_count: number
  org_per_user_storage_gb: number
  org_per_user_storage_total_gb: number
  org_per_user_storage_count: number
  org_per_user_server_count: number
}

export interface OrganizationMetadata {
  limits: OrganizationMetadataLimit
}

export interface OrgProfileMetadata {
  department_name: string
  address1: string
  address2: string
  city: string
  state: string
  country: string
  zip_code: string
  avatar_s3_path: string
  avatar_preview_url: string
}

export interface Organization {
  org_id: number
  name: string
  billing_enabled: boolean
  metadata: OrganizationMetadata
  profile_metadata: OrgProfileMetadata
  created_at: string
  updated_at: string
  owner_id: number
  created_by_user_id: number
  is_default_org: boolean
}

export interface UserProfileMetadata {
  first_name: string
  last_name: string
  avatar_path: string
  avatar_preview_url: string
}

export interface UserOrganizationMetadataLimit {
  org_per_user_storage_gb: number
  org_per_user_storage_total_gb: number
  org_per_user_storage_count: number
  org_per_user_server_count: number
}

export interface UserOrganizationMetadata {
  limits: UserOrganizationMetadataLimit
}

export interface UserOrganization {
  user_id: number
  org_id: number
  user?: User
  organization?: Organization
  metadata?: UserOrganizationMetadata
  profile_metadata?: UserProfileMetadata
  invitation?: Invitation
  role_id: number
  role?: Role
  status: string
  joined_at: string
  created_at: string
}

export interface Invitation {
  invite_id: number
  org_id: number
  organization: Organization
  invite_code: string
  user_id: number
  user: User
  invited_by_user_id: number
  invited_by: User
  created_at: string
  expires_at: string
}

export interface User {
  user_id: number
  email: string
  is_super_admin: boolean
  IsTester: boolean
  created_at: string
  updated_at: string
}

export interface OnLimitReachedOperationArray {
  operations: Array<OnLimitReachedOperation>
}

export interface SpendingLimit {
  id: number
  org_id: number
  user_id?: number
  start_at: string
  term_hours: number
  max_spend_cent: number
  on_limit_reached: OnLimitReachedOperationArray
  repeat: boolean
  created_at: string
  user_organization?: UserOrganization
  user?: User
}

export interface OrganizationMetricData {
  active_user_organization_count: number
  server_instance_count: number
  storage_volume_count: number
  total_storage_volume_size: number
}

export interface AuditLog {
  id: number
  log_type: AuditLogType
  org_id?: number
  user_id?: number
  user?: User
  user_organization?: UserOrganization
  metadata: {[key: string]: any}
  created_at: string
}

export interface InvoiceMetadata {
  download_page: string
}

export interface Invoice {
  stripe_invoice_id: string
  user_id: number
  org_id: number
  metadata: InvoiceMetadata
  amount_cent: number
  created_at: string
  invoice_type: string
  user?: User
  user_organization?: UserOrganization
}

export interface UserSSHKey {
  key_id: number
  user_id: number
  org_id: number
  alias: string
  public_key: string
  created_at?: string
  updated_at?: string
}

export interface GoogleDriveMetadata {
  google_drive_id: number
  url: string
  file_path: string
  status: string
  msg: string
  progress: number
  synced_at: string
}

export interface StorageVolume {
  volume_id: number
  user_id: number
  user?: User
  user_organization?: UserOrganization
  volume_google_drives?: Array<VolumeGoogleDrive>
  org_id: number
  volume_name: string
  size_gb: number
  status: string
  metadata: {[key: string]: any}
  google_drive_metadata?: Array<GoogleDriveMetadata>
  s3_path?: string
  mount_path: string
  is_deleted: boolean
  is_public: boolean
  read_only: boolean
  created_at?: string
  updated_at?: string
  started_at?: string
  destroyed_at?: string
  spend_updated_at?: string
  origin_storage_volume_id?: number
  type_id: number
  storage_volume_type?: StorageVolumeType
  storage_volume_kube?: Array<StorageVolumeKube>
}

export interface StorageVolumeType {
  id: number
  name: string
}

export interface ServerInitCommand {
  command: Array<string>
}

export interface ServerServicePort {
  port: number
  protocol: string
  name: string
}

export interface ServerServiceURL {
  url: string
  name: string
  mapped_port: number
}

export interface ServerInstance {
  instance_id: number
  instance_name: string
  org_id: number
  user_id: number
  user?: User
  user_organization?: UserOrganization
  machine_image: string
  support_ssh: boolean
  service_ports: Array<ServerServicePort>
  service_urls: Array<ServerServiceURL>
  cpu_request_count: number
  cpu_limit_count: number
  ram_request_gb: number
  ram_limit_gb: number
  gpu_request_count: number
  gpu_request_ratio: number
  gpu_request_gmem: number
  ephemeral_storage_request_gb: number
  ephemeral_storage_limit_gb: number
  shm_limit_gb: number
  init_commands?: ServerInitCommand
  metadata: {[key: string]: any}
  created_at?: string
  started_at?: string
  destroyed_at?: string
  template_id: number
  server_template?: ServerTemplate
  is_deleted: boolean
  k8s_namespace: string
  k8s_deployment_name: string
  k8s_deployment_uid: string
  app_name: string
  kube_instance_type_id: number
  spend_updated_at?: string
  auto_shutdown_at?: string
  enabled_scale: boolean
  instance_scale_config?: InstanceScaleConfig
}

export interface ServerTemplate {
  template_id: number
  template_name: string
  org_id: number
  user_id: number
  machine_image: string
  support_ssh: boolean
  service_ports: Array<ServerServicePort>
  cpu_request_count: number
  cpu_limit_count: number
  ram_request_gb: number
  ram_limit_gb: number
  gpu_request_count: number
  gpu_request_ratio: number
  gpu_request_gmem: number
  ephemeral_storage_request_gb: number
  ephemeral_storage_limit_gb: number
  shm_limit_gb: number
  init_commands?: ServerInitCommand
  is_deleted: boolean
  kube_instance_type_id: number
  kube_instance_type: KubeConfInstanceType
  metadata: {[key: string]: any}
  env_var: {[key: string]: string}
  mount_path: {[key: string]: string}
  is_public: boolean
  ssh_required: boolean
  support_pvc: boolean
  created_at: string
  updated_at: string
  is_enabled: boolean
  docker_cred_id: number
  type: ServerTemplateType
  init_command_override?: InitCommandOverride
  support_init_command_override: boolean
  support_scale: boolean
  storage_required: boolean
}

export interface InitCommandOverride {
  var_replace: Array<InitCommandOverrideVarReplaceItem>
  env_config: Array<InitCommandOverrideEnvConfigItem>
}

export interface InitCommandOverrideVarReplaceItem {
  name: string
  default: string
}

export interface InitCommandOverrideEnvConfigItem {
  name: string
  default: string
  required: boolean
}

export interface ResourcePricing {
  pricing_id: number
  resource_type: string
  resource_name?: string
  resource_id?: number
  price_per_hour?: number
  org_id?: number
  effective_from?: string
  effective_to?: string
  is_deleted: boolean
  created_at: string
  updated_at: string
}

export interface Notification {
  notification_id: number
  notification_type: NotificationType
  org_id?: number
  user_id?: number
  title?: string
  detail?: string
  is_read: boolean
  is_email_sent: boolean
  metadata?: {[key: string]: any}
  created_at: string
}

export interface APIKey {
  id: number
  user_id: number
  org_id: number
  key_prefix: string
  key_hash: string
  name: string
  created_at: string
  last_used_at?: string
  is_active: boolean
  is_deleted: boolean
}

export interface EmailOTP {
  id: number
  email: string
  otp_hash: string
  created_at?: string
  expires_at?: string
}

export interface CreditHistoryRecord {
  record_id: number
  org_id: number
  user_id: number
  credit_type: CreditHistoryRecordType
  total_cent: number
  metadata?: {[key: string]: any}
  start_at: string
  end_at: string
  created_at: string
}

export interface KubeConfMetadata {
  SingleGpuMemory: number
}

export interface KubeConf {
  id: number
  config: string
  name: string
  region: string
  kube_type: KubeType
  Metadata: KubeConfMetadata
  sub_domain: string
  created_at: string
  is_enabled: boolean
  prometheus_address: string
  prometheus_username: string
  prometheus_password: string
}

export interface StorageVolumeKube {
  id: number
  storage_volume_id: number
  kube_conf_id: number
  pvc_name: string
  pvc_uid: string
  namespace: string
  storage_class_name: string
  storage_class_uid: string
  metadata: {[key: string]: any}
  is_deleted: boolean
  destroyed_at?: string
  created_at: string
  storage_volume_backups?: Array<StorageVolumeBackup>
  storage_volume_restores?: Array<StorageVolumeRestore>
  node_name: string
}

export interface StorageVolumeServer {
  id: number
  storage_volume_id: number
  instance_id: number
  is_deleted: boolean
  mount_path: string
}

export interface StripeCustomer {
  user_id: number
  stripe_customer_id: string
  user?: User
}

export interface GoogleCred {
  id: number
  config: string
  name: string
  created_at: string
  metadata: {[key: string]: any}
}

export interface GoogleDrive {
  id: number
  user_id: number
  org_id: number
  url: string
  created_at: string
  is_deleted: boolean
  storage_volumes?: Array<StorageVolume>
}

export interface VolumeGoogleDrive {
  id: number
  volume_id: number
  google_drive_id: number
  msg: string
  status: string
  filepath: string
  sync_at: string
  created_at: string
  google_drive?: GoogleDrive
}

export interface GoogleDriveToken {
  id: number
  url: string
  token: string
  created_at: string
  user_id: number
  org_id: number
}

export interface KubeConfInstanceTypeMetadata {
  SingleGpuMemory: number
}

export interface KubeConfInstanceType {
  id: number
  kube_conf_id: number
  metadata: KubeConfInstanceTypeMetadata
  label: string
  is_enabled: boolean
  created_at: string
  kube_conf?: KubeConf
}

export interface DockerCred {
  id: number
  name: string
  user_id: number
  org_id: number
  docker_username: string
  docker_password: string
  created_at: string
}

export interface InstanceScaleConfig {
  id: number
  instance_id: number
  polling_interval: number
  cooldown_period: number
  min_replica_count: number
  max_replica_count: number
}

export interface SpendingLimitAutomation {
  id: number
  spending_limit_id: number
  cent: number
  now_term: number
  max_term: number
  crontab: string
  enabled: boolean
  created_at: string
}

export interface StorageVolumeBackup {
  id: number
  storage_volume_kube_id: number
  backup_job: string
  backup_name: string
  namespace: string
  backup_path: string
  is_deleted: boolean
  created_at: string
  uuid: string
  data_is_deleted: boolean
  status: string
  progress: number
}

export interface StorageVolumeRestore {
  id: number
  storage_volume_kube_id: number
  restore_job: string
  namespace: string
  backup_id: number
  is_deleted: boolean
  created_at: string
  uuid: string
  status: string
  progress: number
}

export enum SortField {
  instance_name = 'instance_name',
  volume_name = 'volume_name',
  started_at = 'started_at',
  created_at = 'created_at',
  joined_at = 'joined_at',
  email = 'email',
  role_name = 'role_name',
  last_name = 'last_name',
  first_name = 'first_name',
  destroyed_at = 'destroyed_at',
  duration_seconds = 'duration_seconds',
  spent = 'spent',
  amount = 'amount'
}

export enum SortDirection {
  asc = 'asc',
  desc = 'desc'
}

export enum ResetOrgUserLimitFields {
  OrgPerUserServerCount = 'OrgPerUserServerCount',
  OrgPerUserStorage = 'OrgPerUserStorage',
  OrgPerUserServerCount_and_OrgPerUserStorage = 'OrgPerUserServerCount_and_OrgPerUserStorage'
}

export interface ServerInstanceSearchParams {
  search_text?: string
}

export interface StorageVolumeSearchParams {
  search_text?: string
}

export interface GetOrgUserSearchParams {
  search_text?: string
}

export interface StatusResponse {
  branch: string
  commit: string
  started: string
  uptime: string
}

export interface CreateOrgInviteRequest {
  email: string
  role: RoleID
}

export interface InviteUserRequest {
  email: string
  role: RoleID
}

export interface UserOrg {
  org: Organization
  user_role: Role
  profile: UserProfileMetadata
  org_user: UserOrganization
  org_user_spend_limit?: SpendingLimit
}

export interface GetOrgMembersRequest {
  status: string
  page_size: number
  page_number: number
  sort_by: string
  sort_direction: string
  search_text: string
}

export interface GetOrgMembersResponse {
  users: Array<UserOrganization>
  total: number
}

export interface GetOrgGraphData {
  server_graph_data: Array<ServerGraphData>
  server_usage_data: Array<ServerUsageData>
}

export interface ServerGraphData {
  datetime: string
  active_servers: number
}

export interface ServerUsageData {
  user_id: number
  template_id: number
  total_usage_time_hours: number
}

export interface GetOrgUsageGraphDataItem {
  date: string
  total_cost: number
}

export interface GetOrgUserMetricItem {
  user?: GetOrgUserMetricUser
  total_usage: Array<GetOrgUserMetricItemUsage>
}

export interface GetOrgUserMetricUser {
  user_id: number
  email: string
  profile_metadata: UserProfileMetadata
}

export interface GetOrgUserMetricItemUsage {
  template_id: number
  hour: number
}

export interface GetOrgServerAnalyticsDataItem {
  duration_seconds: number
  user_id: number
  email: string
  profile_metadata?: UserProfileMetadata
  spent: number
}

export interface GetOrgStorageAnalyticsDataItem {
  duration_seconds: number
  user_id: number
  email: string
  profile_metadata?: UserProfileMetadata
  spent: number
}

export interface GetOrgBalanceSummaryBreakdown {
  total_org_balance: number
  total_user_balance: number
}

export interface GetOrgUserBalanceSummaryBreakdown {
  spending_limit: number
  user_balance: number
}

export interface GetOrgBalanceSummaryData {
  total: number
  spent_total: number
  usage_percent: number
  breakdown: GetOrgBalanceSummaryBreakdown
}

export interface GetOrgUserBalanceSummaryData {
  total: number
  spent_total: number
  usage_percent: number
  breakdown: GetOrgUserBalanceSummaryBreakdown
}

export interface GetSpentBalanceSummaryData {
  total_cost: number
  server_cost: number
  storage_cost: number
}

export interface GetAuditLogRequest {
  user_id?: number
  start_at: number
  end_at: number
  page_size: number
  page_number: number
  sort_by: string
  sort_direction: string
}

export interface UpdateOrgUserLimitRequest {
  user_id: number
  org_per_user_server_count?: number
  org_per_user_storage_gb?: number
  org_per_user_storage_count?: number
}

export interface UpdateOrgLimitReq {
  org_per_user_server_count?: number
  org_per_user_storage_gb?: number
  org_per_user_storage_count?: number
}

export interface CreateOrgPaymentRequest {
  amount: number
  org_id: number
  callback_success_url: string
  callback_cancel_url: string
}

export interface CreateOrgUserPaymentRequest {
  amount: number
  callback_success_url: string
  callback_cancel_url: string
}

export interface GetOrgUserInvoicesRequest {
  page_size: number
  page_number: number
  sort_by: string
  start_at: number
  end_at: number
  sort_direction: string
  search: string
}

export interface GetOrgInvoicesRequest {
  page_size: number
  page_number: number
  sort_by: string
  start_at: number
  end_at: number
  sort_direction: string
  search: string
}

export interface ListStorageVolumeRequest {
  page_size: number
  page_number: number
  status: string
  show_all_users: boolean
  sort_by: string
  sort_direction: string
  search_text: string
  show_public: boolean
}

export interface ListStorageVolumeDataItem {
  user_metadata?: UserProfileMetadata
  storage_volume: StorageVolume
  server_instances: Array<ServerInstance>
}

export interface ServerTemplateRequest {
  template_name: string
  machine_image: string
  support_ssh: boolean
  service_ports: Array<ServerServicePort>
  cpu_request_count: number
  cpu_limit_count: number
  ram_request_gb: number
  ram_limit_gb: number
  gpu_request_count: number
  gpu_request_ratio: number
  gpu_request_gmem: number
  shm_limit_gb: number
  init_commands?: ServerInitCommand
  metadata: {[key: string]: any}
  env_var: {[key: string]: string}
  mount_path: {[key: string]: string}
  ephemeral_storage_request_gb: number
  ephemeral_storage_limit_gb: number
  is_deleted: boolean
  is_public: boolean
  is_enabled: boolean
  ssh_required: boolean
  support_pvc: boolean
  kube_instance_type_id: number
  storage_required: boolean
}

export interface TemplateResponseData {
  template_id: number
  org_id: number
  user_id: number
  template_name: string
  machine_image: string
  support_ssh: boolean
  service_ports: Array<ServerServicePort>
  init_commands?: ServerInitCommand
  cpu_request_count: number
  cpu_limit_count: number
  ram_request_gb: number
  ram_limit_gb: number
  gpu_request_count: number
  gpu_request_gmem: number
  gpu_request_ratio: number
  ephemeral_storage_request_gb: number
  ephemeral_storage_limit_gb: number
  shm_limit_gb: number
  mount_path: {[key: string]: string}
  metadata: {[key: string]: any}
  env_var: {[key: string]: string}
  created_at: string
  updated_at: string
  price: number
  is_public: boolean
  ssh_required: boolean
  support_pvc: boolean
  is_deleted: boolean
  is_enabled: boolean
  kube_instance_type_id: number
  kube_conf_id: number
  ServerTemplateType: ServerTemplateType
  init_command_override?: InitCommandOverride
  support_init_command_override: boolean
  support_scale: boolean
  storage_required: boolean
}

export interface CreateServerInstanceRequest {
  template_id: number
  instance_name: string
  storage_volume_id?: number
  storage_volume_ids?: Array<number>
  allow_ssh: boolean
  extra_ports: Array<number>
  instance_scale_config?: InstanceScaleConfigRequest
  enabled_scale: boolean
  env_var: {[key: string]: string}
  command_vars: {[key: string]: string}
  custom_commands?: Array<string>
  override_docker_image?: string
  override_docker_cred_id?: number
}

export interface InstanceScaleConfigRequest {
  polling_interval: number
  cooldown_period: number
  min_replica_count: number
  max_replica_count: number
}

export interface ListServerInstanceRequest {
  page_number: number
  page_size: number
  show_all_users: boolean
  sort_by: string
  sort_direction: string
  search_text: string
}

export interface ListServerInstanceItem {
  instance_id: number
  instance_name: string
  org_id: number
  user_metadata?: UserProfileMetadata
  user_id: number
  template_id: number
  template_name: string
  created_at?: string
  status: string
  started_at?: string
  email: string
  destroyed_at?: string
  price: number
  template?: TemplateResponseData
  terminal_reason: string
  terminal_message: string
  restart_count: number
  terminal_exit_code: number
  terminal_finished_at?: string
  enable_scale: boolean
  instance_scale_config?: InstanceScaleConfig
  replica_status?: ReplicaStatus
  node_name: string
}

export interface ReplicaStatus {
  replicas: number
  ready_replicas: number
  available_replicas: number
  unavailable_replicas: number
}

export interface GetServerInstanceData {
  metadata: {[key: string]: any}
  image: string
  service_ports: Array<ServerServicePort>
  service_urls: Array<ServerServiceURL>
  email: string
  template_name: string
  instance_name: string
  started_at?: string
  created_at?: string
  destroyed_at?: string
  auto_shutdown_at?: string
  cpu_request_count: number
  cpu_limit_count: number
  ram_request_gb: number
  ram_limit_gb: number
  gpu_request_count: number
  gpu_request_ratio: number
  gpu_request_gmem: number
  ephemeral_storage_request_gb: number
  ephemeral_storage_limit_gb: number
  ephemeral_storage_usage_bytes: number
  shm_limit_gb: number
  status: string
  price: number
  storage_volume_info: Array<StorageVolumeServer>
  terminal_reason: string
  terminal_message: string
  restart_count: number
  terminal_exit_code: number
  terminal_finished_at?: string
  instance_scale_config?: InstanceScaleConfig
  enable_scale: boolean
  replica_status?: ReplicaStatus
  template_id: number
  node_name: string
}

export interface ServerInstanceMetricsCPU {
  limit: number
  usage: number
}

export interface ServerInstanceMetricsMemory {
  limit: number
  usage: number
}

export interface ServerInstanceMetrics {
  cpu: ServerInstanceMetricsCPU
  memory: ServerInstanceMetricsMemory
  timestamp: string
}

export interface UploadFileData {
  s3_path: string
  preview_url: string
}

export interface File {
  file_name: string
  file_type: string
  file_content: string
}

export interface ListServerTemplateRequest {
  page_size: number
  page_number: number
  is_public: boolean
}

export interface UpdateOrgProfileRequest {
  org_name: string
  department_name: string
  address1: string
  address2: string
  city: string
  state: string
  zip_code: string
  country: string
  avatar?: File
}

export interface UsersLimitsReturn {
  user_limit: UserLimit
  user_organization: UserOrganization
  user: User
}

export interface GoogleDriveInitData {
  google_drive_id: number
  file_path: string
}

export interface UpdateStorageVolumeData {
  name: string
  is_public: boolean
  google_drive_metadata: Array<GoogleDriveInitData>
}

export interface GetOrgCreditAnalyticsData {
  user_id: number
  email: string
  profile_metadata?: UserProfileMetadata
  balance_summary: GetOrgUserBalanceSummaryData
  left_time: number
}

export interface GetOrgCreditAnalyticsRequest {
  sort_by: string
  sort_direction: string
  page_size: number
  page_number: number
}

export interface InstanceScaleHistoryItem {
  ts: number
  value: number
}

export interface CreateSpendingLimitAutomationReq {
  spending_limit_id: number
  cent: number
  enable: boolean
  max_term: number
  crontab: string
}

export interface StorageBackupCallbackRequest {
  uuid: string
  progress: number
  job_type: string
  status: string
  restore_volume_id: number
}

export interface SetAutoShutdownRequest {
  instance_id: number
  timestamp?: number
}

export interface ExternalCreateServerInstanceRequest {
  template_id: number
  instance_name: string
  storage_volume_id?: number
  allow_ssh: boolean
  extra_ports: Array<number>
}

export interface SetUpNewOrg {
  org_name: string
  users: Array<SetUpNewOrgUser>
  template_ids: Array<number>
  price: Array<number>
  limits?: OrganizationMetadataLimit
  start_credit: number
}

export interface SetUpNewOrgUser {
  email: string
  role_id: number
}

export interface Inference {
  /**
   * ------ PUBLIC ROUTES ------
   */
  requestOTP(args: RequestOTPArgs, headers?: object, signal?: AbortSignal): Promise<RequestOTPReturn>
  login(args: LoginArgs, headers?: object, signal?: AbortSignal): Promise<LoginReturn>
  storageBackupCallback(args: StorageBackupCallbackArgs, headers?: object, signal?: AbortSignal): Promise<StorageBackupCallbackReturn>
  /**
   * ------ PRIVATE ROUTES ------
   */
  createOrgInvite(args: CreateOrgInviteArgs, headers?: object, signal?: AbortSignal): Promise<CreateOrgInviteReturn>
  createOrgInviteBatch(args: CreateOrgInviteBatchArgs, headers?: object, signal?: AbortSignal): Promise<CreateOrgInviteBatchReturn>
  createOrg(args: CreateOrgArgs, headers?: object, signal?: AbortSignal): Promise<CreateOrgReturn>
  getUserOrgs(headers?: object, signal?: AbortSignal): Promise<GetUserOrgsReturn>
  getOrgUsers(args: GetOrgUsersArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgUsersReturn>
  getOrg(headers?: object, signal?: AbortSignal): Promise<GetOrgReturn>
  updateOrgUser(args: UpdateOrgUserArgs, headers?: object, signal?: AbortSignal): Promise<UpdateOrgUserReturn>
  deleteOrgUser(args: DeleteOrgUserArgs, headers?: object, signal?: AbortSignal): Promise<DeleteOrgUserReturn>
  /**
   * - UpdateOrgUserProfile(first_name: string, last_name: string) => (ok: bool)
   */
  updateOrgUserProfileV2(args: UpdateOrgUserProfileV2Args, headers?: object, signal?: AbortSignal): Promise<UpdateOrgUserProfileV2Return>
  updateOrgProfile(args: UpdateOrgProfileArgs, headers?: object, signal?: AbortSignal): Promise<UpdateOrgProfileReturn>
  getOrgMetric(args: GetOrgMetricArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgMetricReturn>
  getOrgGraph(args: GetOrgGraphArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgGraphReturn>
  getOrgUsageGraph(args: GetOrgUsageGraphArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgUsageGraphReturn>
  getOrgUserGraph(args: GetOrgUserGraphArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgUserGraphReturn>
  getOrgServerAnalytics(args: GetOrgServerAnalyticsArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgServerAnalyticsReturn>
  getOrgStorageAnalytics(args: GetOrgStorageAnalyticsArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgStorageAnalyticsReturn>
  getOrgBalanceSummary(headers?: object, signal?: AbortSignal): Promise<GetOrgBalanceSummaryReturn>
  getOrgUserBalanceSummary(headers?: object, signal?: AbortSignal): Promise<GetOrgUserBalanceSummaryReturn>
  getOrgSpendRate(headers?: object, signal?: AbortSignal): Promise<GetOrgSpendRateReturn>
  getOrgUserSpendRate(headers?: object, signal?: AbortSignal): Promise<GetOrgUserSpendRateReturn>
  getAuditLogs(args: GetAuditLogsArgs, headers?: object, signal?: AbortSignal): Promise<GetAuditLogsReturn>
  getOrgCreditAnalytics(args: GetOrgCreditAnalyticsArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgCreditAnalyticsReturn>
  createOrgSpendingLimit(args: CreateOrgSpendingLimitArgs, headers?: object, signal?: AbortSignal): Promise<CreateOrgSpendingLimitReturn>
  getOrgSpendingLimit(headers?: object, signal?: AbortSignal): Promise<GetOrgSpendingLimitReturn>
  createOrgUserSpendingLimit(args: CreateOrgUserSpendingLimitArgs, headers?: object, signal?: AbortSignal): Promise<CreateOrgUserSpendingLimitReturn>
  resetOrgUserSpendingLimit(args: ResetOrgUserSpendingLimitArgs, headers?: object, signal?: AbortSignal): Promise<ResetOrgUserSpendingLimitReturn>
  getOrgUserSpendingLimit(args: GetOrgUserSpendingLimitArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgUserSpendingLimitReturn>
  getOrgUsersSpendingLimit(args: GetOrgUsersSpendingLimitArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgUsersSpendingLimitReturn>
  createSpendingLimitAutomation(args: CreateSpendingLimitAutomationArgs, headers?: object, signal?: AbortSignal): Promise<CreateSpendingLimitAutomationReturn>
  deleteSpendingLimitAutomation(args: DeleteSpendingLimitAutomationArgs, headers?: object, signal?: AbortSignal): Promise<DeleteSpendingLimitAutomationReturn>
  getSpendingLimitAutomation(args: GetSpendingLimitAutomationArgs, headers?: object, signal?: AbortSignal): Promise<GetSpendingLimitAutomationReturn>
  listSpendingLimitAutomations(args: ListSpendingLimitAutomationsArgs, headers?: object, signal?: AbortSignal): Promise<ListSpendingLimitAutomationsReturn>
  getOrgUserLimit(args: GetOrgUserLimitArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgUserLimitReturn>
  getOrgUsersLimit(args: GetOrgUsersLimitArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgUsersLimitReturn>
  getOrgLimit(headers?: object, signal?: AbortSignal): Promise<GetOrgLimitReturn>
  updateOrgUserLimit(args: UpdateOrgUserLimitArgs, headers?: object, signal?: AbortSignal): Promise<UpdateOrgUserLimitReturn>
  resetOrgUserLimit(args: ResetOrgUserLimitArgs, headers?: object, signal?: AbortSignal): Promise<ResetOrgUserLimitReturn>
  updateOrgLimit(args: UpdateOrgLimitArgs, headers?: object, signal?: AbortSignal): Promise<UpdateOrgLimitReturn>
  createOrgPayment(args: CreateOrgPaymentArgs, headers?: object, signal?: AbortSignal): Promise<CreateOrgPaymentReturn>
  createOrgUserPayment(args: CreateOrgUserPaymentArgs, headers?: object, signal?: AbortSignal): Promise<CreateOrgUserPaymentReturn>
  getOrgInvoices(args: GetOrgInvoicesArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgInvoicesReturn>
  getOrgUserInvoices(args: GetOrgUserInvoicesArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgUserInvoicesReturn>
  createSSHKey(args: CreateSSHKeyArgs, headers?: object, signal?: AbortSignal): Promise<CreateSSHKeyReturn>
  listSSHKeys(args: ListSSHKeysArgs, headers?: object, signal?: AbortSignal): Promise<ListSSHKeysReturn>
  deleteSSHKey(args: DeleteSSHKeyArgs, headers?: object, signal?: AbortSignal): Promise<DeleteSSHKeyReturn>
  createStorageVolume(args: CreateStorageVolumeArgs, headers?: object, signal?: AbortSignal): Promise<CreateStorageVolumeReturn>
  listStorageVolumes(args: ListStorageVolumesArgs, headers?: object, signal?: AbortSignal): Promise<ListStorageVolumesReturn>
  deleteStorageVolume(args: DeleteStorageVolumeArgs, headers?: object, signal?: AbortSignal): Promise<DeleteStorageVolumeReturn>
  getStorageVolumeInfo(args: GetStorageVolumeInfoArgs, headers?: object, signal?: AbortSignal): Promise<GetStorageVolumeInfoReturn>
  syncStorageGoogleDrive(args: SyncStorageGoogleDriveArgs, headers?: object, signal?: AbortSignal): Promise<SyncStorageGoogleDriveReturn>
  updateStorageVolume(args: UpdateStorageVolumeArgs, headers?: object, signal?: AbortSignal): Promise<UpdateStorageVolumeReturn>
  createGoogleDriveToken(args: CreateGoogleDriveTokenArgs, headers?: object, signal?: AbortSignal): Promise<CreateGoogleDriveTokenReturn>
  deleteGoogleDriveToken(args: DeleteGoogleDriveTokenArgs, headers?: object, signal?: AbortSignal): Promise<DeleteGoogleDriveTokenReturn>
  listGoogleDriveTokens(args: ListGoogleDriveTokensArgs, headers?: object, signal?: AbortSignal): Promise<ListGoogleDriveTokensReturn>
  addGoogleDrive(args: AddGoogleDriveArgs, headers?: object, signal?: AbortSignal): Promise<AddGoogleDriveReturn>
  deleteGoogleDrive(args: DeleteGoogleDriveArgs, headers?: object, signal?: AbortSignal): Promise<DeleteGoogleDriveReturn>
  listGoogleDrive(args: ListGoogleDriveArgs, headers?: object, signal?: AbortSignal): Promise<ListGoogleDriveReturn>
  createStorageBackup(args: CreateStorageBackupArgs, headers?: object, signal?: AbortSignal): Promise<CreateStorageBackupReturn>
  restoreStorageBackup(args: RestoreStorageBackupArgs, headers?: object, signal?: AbortSignal): Promise<RestoreStorageBackupReturn>
  createServerTemplate(args: CreateServerTemplateArgs, headers?: object, signal?: AbortSignal): Promise<CreateServerTemplateReturn>
  updateServerTemplate(args: UpdateServerTemplateArgs, headers?: object, signal?: AbortSignal): Promise<UpdateServerTemplateReturn>
  listServerTemplates(args: ListServerTemplatesArgs, headers?: object, signal?: AbortSignal): Promise<ListServerTemplatesReturn>
  deleteServerTemplate(args: DeleteServerTemplateArgs, headers?: object, signal?: AbortSignal): Promise<DeleteServerTemplateReturn>
  getServerTemplate(args: GetServerTemplateArgs, headers?: object, signal?: AbortSignal): Promise<GetServerTemplateReturn>
  getServerTemplatePrice(args: GetServerTemplatePriceArgs, headers?: object, signal?: AbortSignal): Promise<GetServerTemplatePriceReturn>
  listPublicServerTemplates(args: ListPublicServerTemplatesArgs, headers?: object, signal?: AbortSignal): Promise<ListPublicServerTemplatesReturn>
  createServerInstance(args: CreateServerInstanceArgs, headers?: object, signal?: AbortSignal): Promise<CreateServerInstanceReturn>
  listServerInstances(args: ListServerInstancesArgs, headers?: object, signal?: AbortSignal): Promise<ListServerInstancesReturn>
  deleteServerInstance(args: DeleteServerInstanceArgs, headers?: object, signal?: AbortSignal): Promise<DeleteServerInstanceReturn>
  getServerInstance(args: GetServerInstanceArgs, headers?: object, signal?: AbortSignal): Promise<GetServerInstanceReturn>
  updateServerInstance(args: UpdateServerInstanceArgs, headers?: object, signal?: AbortSignal): Promise<UpdateServerInstanceReturn>
  getServerInstanceMetrics(args: GetServerInstanceMetricsArgs, headers?: object, signal?: AbortSignal): Promise<GetServerInstanceMetricsReturn>
  getServerInstancePodName(args: GetServerInstancePodNameArgs, headers?: object, signal?: AbortSignal): Promise<GetServerInstancePodNameReturn>
  getServerWebSSHSession(args: GetServerWebSSHSessionArgs, headers?: object, signal?: AbortSignal): Promise<GetServerWebSSHSessionReturn>
  updateServerInstanceScaleConfig(args: UpdateServerInstanceScaleConfigArgs, headers?: object, signal?: AbortSignal): Promise<UpdateServerInstanceScaleConfigReturn>
  getServerInstanceScaleHistory(args: GetServerInstanceScaleHistoryArgs, headers?: object, signal?: AbortSignal): Promise<GetServerInstanceScaleHistoryReturn>
  mountStorage(args: MountStorageArgs, headers?: object, signal?: AbortSignal): Promise<MountStorageReturn>
  setAutoShutdown(args: SetAutoShutdownArgs, headers?: object, signal?: AbortSignal): Promise<SetAutoShutdownReturn>
  listNotifications(args: ListNotificationsArgs, headers?: object, signal?: AbortSignal): Promise<ListNotificationsReturn>
  markNotificationRead(args: MarkNotificationReadArgs, headers?: object, signal?: AbortSignal): Promise<MarkNotificationReadReturn>
  createAPIKey(args: CreateAPIKeyArgs, headers?: object, signal?: AbortSignal): Promise<CreateAPIKeyReturn>
  listAPIKeys(headers?: object, signal?: AbortSignal): Promise<ListAPIKeysReturn>
  deleteAPIKey(args: DeleteAPIKeyArgs, headers?: object, signal?: AbortSignal): Promise<DeleteAPIKeyReturn>
  createDockerCred(args: CreateDockerCredArgs, headers?: object, signal?: AbortSignal): Promise<CreateDockerCredReturn>
  listDockerCreds(args: ListDockerCredsArgs, headers?: object, signal?: AbortSignal): Promise<ListDockerCredsReturn>
  deleteDockerCred(args: DeleteDockerCredArgs, headers?: object, signal?: AbortSignal): Promise<DeleteDockerCredReturn>
}

export interface RequestOTPArgs {
  email: string
}

export interface RequestOTPReturn {
  ok: boolean  
}
export interface LoginArgs {
  email: string
  otp: string
  invite_code?: string
}

export interface LoginReturn {
  token: string  
}
export interface StorageBackupCallbackArgs {
  progress: number
  label: string
  ts: string
  uuid: string
  status: string
  command: string
  auto_restore: boolean
  migrate_storage_volume_kube_id: number
}

export interface StorageBackupCallbackReturn {
  ok: boolean  
}
export interface CreateOrgInviteArgs {
  request: CreateOrgInviteRequest
}

export interface CreateOrgInviteReturn {
  ok: boolean  
}
export interface CreateOrgInviteBatchArgs {
  invites: Array<InviteUserRequest>
}

export interface CreateOrgInviteBatchReturn {
  ok: boolean  
}
export interface CreateOrgArgs {
  name: string
}

export interface CreateOrgReturn {
  org_id: number  
}
export interface GetUserOrgsArgs {
}

export interface GetUserOrgsReturn {
  orgs: Array<UserOrg>  
}
export interface GetOrgUsersArgs {
  request: GetOrgMembersRequest
}

export interface GetOrgUsersReturn {
  users: Array<UserOrganization>
  total: number  
}
export interface GetOrgArgs {
}

export interface GetOrgReturn {
  org: Organization  
}
export interface UpdateOrgUserArgs {
  user_id: number
  role_id: RoleID
}

export interface UpdateOrgUserReturn {
  ok: boolean  
}
export interface DeleteOrgUserArgs {
  user_id: number
  delete_resource?: boolean
}

export interface DeleteOrgUserReturn {
  ok: boolean  
}
export interface UpdateOrgUserProfileV2Args {
  first_name: string
  last_name: string
  file?: File
}

export interface UpdateOrgUserProfileV2Return {
  ok: boolean  
}
export interface UpdateOrgProfileArgs {
  args: UpdateOrgProfileRequest
}

export interface UpdateOrgProfileReturn {
  ok: boolean  
}
export interface GetOrgMetricArgs {
  user_id?: number
}

export interface GetOrgMetricReturn {
  metric: OrganizationMetricData  
}
export interface GetOrgGraphArgs {
  user_id?: number
  start_at: number
  end_at: number
  interval: string
}

export interface GetOrgGraphReturn {
  graph: GetOrgGraphData  
}
export interface GetOrgUsageGraphArgs {
  user_id?: number
  start_at: number
  end_at: number
}

export interface GetOrgUsageGraphReturn {
  items: Array<GetOrgUsageGraphDataItem>  
}
export interface GetOrgUserGraphArgs {
  start_at: number
  end_at: number
}

export interface GetOrgUserGraphReturn {
  items: Array<GetOrgUserMetricItem>  
}
export interface GetOrgServerAnalyticsArgs {
  start_at: number
  end_at: number
  sort_by: string
  sort_direction: string
}

export interface GetOrgServerAnalyticsReturn {
  items: Array<GetOrgServerAnalyticsDataItem>
  total_duration_seconds: number
  total_spent: number  
}
export interface GetOrgStorageAnalyticsArgs {
  start_at: number
  end_at: number
  sort_by: string
  sort_direction: string
}

export interface GetOrgStorageAnalyticsReturn {
  items: Array<GetOrgStorageAnalyticsDataItem>
  total_duration_seconds: number
  total_spent: number  
}
export interface GetOrgBalanceSummaryArgs {
}

export interface GetOrgBalanceSummaryReturn {
  summary: GetOrgBalanceSummaryData  
}
export interface GetOrgUserBalanceSummaryArgs {
}

export interface GetOrgUserBalanceSummaryReturn {
  summary: GetOrgUserBalanceSummaryData  
}
export interface GetOrgSpendRateArgs {
}

export interface GetOrgSpendRateReturn {
  summary: GetSpentBalanceSummaryData  
}
export interface GetOrgUserSpendRateArgs {
}

export interface GetOrgUserSpendRateReturn {
  summary: GetSpentBalanceSummaryData  
}
export interface GetAuditLogsArgs {
  data: GetAuditLogRequest
}

export interface GetAuditLogsReturn {
  items: Array<AuditLog>
  total: number  
}
export interface GetOrgCreditAnalyticsArgs {
  request: GetOrgCreditAnalyticsRequest
}

export interface GetOrgCreditAnalyticsReturn {
  items: Array<GetOrgCreditAnalyticsData>
  total: number  
}
export interface CreateOrgSpendingLimitArgs {
  cent: number
}

export interface CreateOrgSpendingLimitReturn {
  ok: boolean  
}
export interface GetOrgSpendingLimitArgs {
}

export interface GetOrgSpendingLimitReturn {
  spending_limit: SpendingLimit  
}
export interface CreateOrgUserSpendingLimitArgs {
  user_id: number
  cent: number
}

export interface CreateOrgUserSpendingLimitReturn {
  ok: boolean  
}
export interface ResetOrgUserSpendingLimitArgs {
  user_id: number
}

export interface ResetOrgUserSpendingLimitReturn {
  ok: boolean  
}
export interface GetOrgUserSpendingLimitArgs {
  user_id: number
}

export interface GetOrgUserSpendingLimitReturn {
  spending_limit: SpendingLimit  
}
export interface GetOrgUsersSpendingLimitArgs {
  page: number
  page_size: number
}

export interface GetOrgUsersSpendingLimitReturn {
  spending_limits: Array<SpendingLimit>
  total: number  
}
export interface CreateSpendingLimitAutomationArgs {
  req: CreateSpendingLimitAutomationReq
}

export interface CreateSpendingLimitAutomationReturn {
  ok: boolean  
}
export interface DeleteSpendingLimitAutomationArgs {
  auto_id: number
}

export interface DeleteSpendingLimitAutomationReturn {
  ok: boolean  
}
export interface GetSpendingLimitAutomationArgs {
  auto_id: number
}

export interface GetSpendingLimitAutomationReturn {
  data: SpendingLimitAutomation  
}
export interface ListSpendingLimitAutomationsArgs {
  spending_limit_id: number
}

export interface ListSpendingLimitAutomationsReturn {
  automations: Array<SpendingLimitAutomation>  
}
export interface GetOrgUserLimitArgs {
  user_id: number
}

export interface GetOrgUserLimitReturn {
  limit: UserLimit  
}
export interface GetOrgUsersLimitArgs {
  page: number
  page_size: number
}

export interface GetOrgUsersLimitReturn {
  limits: Array<UsersLimitsReturn>
  total: number  
}
export interface GetOrgLimitArgs {
}

export interface GetOrgLimitReturn {
  limit: OrganizationMetadataLimit  
}
export interface UpdateOrgUserLimitArgs {
  request: UpdateOrgUserLimitRequest
}

export interface UpdateOrgUserLimitReturn {
  ok: boolean  
}
export interface ResetOrgUserLimitArgs {
  user_id: number
  fields: ResetOrgUserLimitFields
}

export interface ResetOrgUserLimitReturn {
  ok: boolean  
}
export interface UpdateOrgLimitArgs {
  request: UpdateOrgLimitReq
}

export interface UpdateOrgLimitReturn {
  ok: boolean  
}
export interface CreateOrgPaymentArgs {
  request: CreateOrgPaymentRequest
}

export interface CreateOrgPaymentReturn {
  url: string
  id: string  
}
export interface CreateOrgUserPaymentArgs {
  request: CreateOrgUserPaymentRequest
}

export interface CreateOrgUserPaymentReturn {
  url: string
  id: string  
}
export interface GetOrgInvoicesArgs {
  request: GetOrgInvoicesRequest
}

export interface GetOrgInvoicesReturn {
  items: Array<Invoice>
  total: number  
}
export interface GetOrgUserInvoicesArgs {
  request: GetOrgUserInvoicesRequest
}

export interface GetOrgUserInvoicesReturn {
  items: Array<Invoice>
  total: number  
}
export interface CreateSSHKeyArgs {
  alias: string
  public_key: string
}

export interface CreateSSHKeyReturn {
  ok: boolean  
}
export interface ListSSHKeysArgs {
  page_size: number
  page_number: number
}

export interface ListSSHKeysReturn {
  keys: Array<UserSSHKey>
  total: number  
}
export interface DeleteSSHKeyArgs {
  key_id: number
}

export interface DeleteSSHKeyReturn {
  ok: boolean  
}
export interface CreateStorageVolumeArgs {
  name: string
  size_gb: number
  read_only: boolean
  is_public: boolean
  google_drive_metadata: Array<GoogleDriveInitData>
  type_id: number
}

export interface CreateStorageVolumeReturn {
  ok: boolean  
}
export interface ListStorageVolumesArgs {
  page: ListStorageVolumeRequest
}

export interface ListStorageVolumesReturn {
  volumes: Array<ListStorageVolumeDataItem>
  total: number  
}
export interface DeleteStorageVolumeArgs {
  volume_id: number
}

export interface DeleteStorageVolumeReturn {
  ok: boolean  
}
export interface GetStorageVolumeInfoArgs {
  volume_id: number
}

export interface GetStorageVolumeInfoReturn {
  volume: StorageVolume  
}
export interface SyncStorageGoogleDriveArgs {
  volume_id: number
}

export interface SyncStorageGoogleDriveReturn {
  ok: boolean  
}
export interface UpdateStorageVolumeArgs {
  volume_id: number
  data: UpdateStorageVolumeData
}

export interface UpdateStorageVolumeReturn {
  ok: boolean  
}
export interface CreateGoogleDriveTokenArgs {
  url: string
}

export interface CreateGoogleDriveTokenReturn {
  token: string  
}
export interface DeleteGoogleDriveTokenArgs {
  id: number
}

export interface DeleteGoogleDriveTokenReturn {
  ok: boolean  
}
export interface ListGoogleDriveTokensArgs {
  page_size: number
  page_number: number
}

export interface ListGoogleDriveTokensReturn {
  items: Array<GoogleDriveToken>
  total: number  
}
export interface AddGoogleDriveArgs {
  url: string
  token: string
  email: string
}

export interface AddGoogleDriveReturn {
  item: GoogleDrive  
}
export interface DeleteGoogleDriveArgs {
  id: number
}

export interface DeleteGoogleDriveReturn {
  ok: boolean  
}
export interface ListGoogleDriveArgs {
  page_size: number
  page_number: number
}

export interface ListGoogleDriveReturn {
  items: Array<GoogleDrive>
  total: number  
}
export interface CreateStorageBackupArgs {
  storage_volume_kube_id: number
}

export interface CreateStorageBackupReturn {
  item: StorageVolumeBackup  
}
export interface RestoreStorageBackupArgs {
  storage_volume_kube_id: number
  backup_id: number
}

export interface RestoreStorageBackupReturn {
  ok: boolean  
}
export interface CreateServerTemplateArgs {
  request: ServerTemplateRequest
  price_per_hour: number
}

export interface CreateServerTemplateReturn {
  ok: boolean  
}
export interface UpdateServerTemplateArgs {
  template_id: number
  request: ServerTemplateRequest
}

export interface UpdateServerTemplateReturn {
  ok: boolean  
}
export interface ListServerTemplatesArgs {
  request: ListServerTemplateRequest
}

export interface ListServerTemplatesReturn {
  templates: Array<TemplateResponseData>
  total: number  
}
export interface DeleteServerTemplateArgs {
  template_id: number
}

export interface DeleteServerTemplateReturn {
  ok: boolean  
}
export interface GetServerTemplateArgs {
  template_id: number
}

export interface GetServerTemplateReturn {
  template: TemplateResponseData  
}
export interface GetServerTemplatePriceArgs {
  template_id: number
}

export interface GetServerTemplatePriceReturn {
  price: ResourcePricing  
}
export interface ListPublicServerTemplatesArgs {
  page_size: number
  page_number: number
}

export interface ListPublicServerTemplatesReturn {
  templates: Array<TemplateResponseData>
  total: number  
}
export interface CreateServerInstanceArgs {
  request: CreateServerInstanceRequest
}

export interface CreateServerInstanceReturn {
  instance_id: number  
}
export interface ListServerInstancesArgs {
  request: ListServerInstanceRequest
}

export interface ListServerInstancesReturn {
  instances: Array<ListServerInstanceItem>
  total: number  
}
export interface DeleteServerInstanceArgs {
  instance_id: number
}

export interface DeleteServerInstanceReturn {
  ok: boolean  
}
export interface GetServerInstanceArgs {
  instance_id: number
}

export interface GetServerInstanceReturn {
  instance: GetServerInstanceData  
}
export interface UpdateServerInstanceArgs {
  instance_id: number
  instance_name: string
}

export interface UpdateServerInstanceReturn {
  ok: boolean  
}
export interface GetServerInstanceMetricsArgs {
  instance_id: number
}

export interface GetServerInstanceMetricsReturn {
  metrics: Array<ServerInstanceMetrics>  
}
export interface GetServerInstancePodNameArgs {
  instance_id: number
}

export interface GetServerInstancePodNameReturn {
  pod_name: Array<string>  
}
export interface GetServerWebSSHSessionArgs {
  instance_id: number
}

export interface GetServerWebSSHSessionReturn {
  url: string
  pid: number  
}
export interface UpdateServerInstanceScaleConfigArgs {
  config_id: number
  config: InstanceScaleConfigRequest
}

export interface UpdateServerInstanceScaleConfigReturn {
  ok: boolean  
}
export interface GetServerInstanceScaleHistoryArgs {
  instance_id: number
  start_at: number
  end_at: number
  unit: string
}

export interface GetServerInstanceScaleHistoryReturn {
  items: Array<InstanceScaleHistoryItem>  
}
export interface MountStorageArgs {
  instance_id: number
  volume_ids: Array<number>
}

export interface MountStorageReturn {
  ok: boolean  
}
export interface SetAutoShutdownArgs {
  request: SetAutoShutdownRequest
}

export interface SetAutoShutdownReturn {
  ok: boolean  
}
export interface ListNotificationsArgs {
  page_size: number
  page_number: number
  notification_type?: NotificationType
  unread?: boolean
}

export interface ListNotificationsReturn {
  notifications: Array<Notification>
  total: number  
}
export interface MarkNotificationReadArgs {
  notification_id: number
}

export interface MarkNotificationReadReturn {
  ok: boolean  
}
export interface CreateAPIKeyArgs {
  name: string
}

export interface CreateAPIKeyReturn {
  api_key: string  
}
export interface ListAPIKeysArgs {
}

export interface ListAPIKeysReturn {
  api_keys: Array<APIKey>
  total: number  
}
export interface DeleteAPIKeyArgs {
  api_key_id: number
}

export interface DeleteAPIKeyReturn {
  ok: boolean  
}
export interface CreateDockerCredArgs {
  name: string
  docker_username: string
  docker_password: string
}

export interface CreateDockerCredReturn {
  ok: boolean  
}
export interface ListDockerCredsArgs {
  page_size: number
  page_number: number
}

export interface ListDockerCredsReturn {
  creds: Array<DockerCred>
  total: number  
}
export interface DeleteDockerCredArgs {
  id: number
}

export interface DeleteDockerCredReturn {
  ok: boolean  
}

export interface InferenceExternal {
  externalListServerInstances(args: ExternalListServerInstancesArgs, headers?: object, signal?: AbortSignal): Promise<ExternalListServerInstancesReturn>
  externalCreateServerInstance(args: ExternalCreateServerInstanceArgs, headers?: object, signal?: AbortSignal): Promise<ExternalCreateServerInstanceReturn>
  externalDeleteServerInstance(args: ExternalDeleteServerInstanceArgs, headers?: object, signal?: AbortSignal): Promise<ExternalDeleteServerInstanceReturn>
  externalListServerTemplates(args: ExternalListServerTemplatesArgs, headers?: object, signal?: AbortSignal): Promise<ExternalListServerTemplatesReturn>
  externalListStorageVolumes(args: ExternalListStorageVolumesArgs, headers?: object, signal?: AbortSignal): Promise<ExternalListStorageVolumesReturn>
}

export interface ExternalListServerInstancesArgs {
  page_number: number
  page_size: number
}

export interface ExternalListServerInstancesReturn {
  instances: Array<ListServerInstanceItem>
  total: number  
}
export interface ExternalCreateServerInstanceArgs {
  request: ExternalCreateServerInstanceRequest
}

export interface ExternalCreateServerInstanceReturn {
  ok: boolean  
}
export interface ExternalDeleteServerInstanceArgs {
  instance_id: number
}

export interface ExternalDeleteServerInstanceReturn {
  ok: boolean  
}
export interface ExternalListServerTemplatesArgs {
  page_size: number
  page_number: number
}

export interface ExternalListServerTemplatesReturn {
  templates: Array<TemplateResponseData>
  total: number  
}
export interface ExternalListStorageVolumesArgs {
  page_size: number
  page_number: number
}

export interface ExternalListStorageVolumesReturn {
  volumes: Array<ListStorageVolumeDataItem>
  total: number  
}

export interface InferenceInternal {
  createOrg(args: CreateOrgArgs, headers?: object, signal?: AbortSignal): Promise<CreateOrgReturn>
  createUser(args: CreateUserArgs, headers?: object, signal?: AbortSignal): Promise<CreateUserReturn>
  getUser(args: GetUserArgs, headers?: object, signal?: AbortSignal): Promise<GetUserReturn>
  setOrgUser(args: SetOrgUserArgs, headers?: object, signal?: AbortSignal): Promise<SetOrgUserReturn>
  addOrgCredit(args: AddOrgCreditArgs, headers?: object, signal?: AbortSignal): Promise<AddOrgCreditReturn>
  setOrgLimit(args: SetOrgLimitArgs, headers?: object, signal?: AbortSignal): Promise<SetOrgLimitReturn>
  addKubeConfig(args: AddKubeConfigArgs, headers?: object, signal?: AbortSignal): Promise<AddKubeConfigReturn>
  deductOrgCredit(args: DeductOrgCreditArgs, headers?: object, signal?: AbortSignal): Promise<DeductOrgCreditReturn>
  deductOrgUserCredit(args: DeductOrgUserCreditArgs, headers?: object, signal?: AbortSignal): Promise<DeductOrgUserCreditReturn>
  deductFakeResourceCost(args: DeductFakeResourceCostArgs, headers?: object, signal?: AbortSignal): Promise<DeductFakeResourceCostReturn>
  testDeductCredit(headers?: object, signal?: AbortSignal): Promise<TestDeductCreditReturn>
  setUpNewOrg(args: SetUpNewOrgArgs, headers?: object, signal?: AbortSignal): Promise<SetUpNewOrgReturn>
  kubeConfDetails(headers?: object, signal?: AbortSignal): Promise<KubeConfDetailsReturn>
}

export interface CreateOrgArgs {
  name: string
}

export interface CreateOrgReturn {
  org_id: number  
}
export interface CreateUserArgs {
  email: string
}

export interface CreateUserReturn {
  user_id: number  
}
export interface GetUserArgs {
  email: string
}

export interface GetUserReturn {
  user_orgs: Array<UserOrg>  
}
export interface SetOrgUserArgs {
  org_id: number
  user_id: number
  role_id: RoleID
}

export interface SetOrgUserReturn {
  ok: boolean  
}
export interface AddOrgCreditArgs {
  org_id: number
  user_id: number
  cents: number
}

export interface AddOrgCreditReturn {
  ok: boolean  
}
export interface SetOrgLimitArgs {
  org_id: number
  limits: OrganizationMetadataLimit
}

export interface SetOrgLimitReturn {
  ok: boolean  
}
export interface AddKubeConfigArgs {
  name: string
  config: string
  region: string
}

export interface AddKubeConfigReturn {
  ok: boolean  
}
export interface DeductOrgCreditArgs {
  org_id: number
  user_id: number
  cent: number
}

export interface DeductOrgCreditReturn {
  ok: boolean  
}
export interface DeductOrgUserCreditArgs {
  org_id: number
  user_id: number
  cent: number
}

export interface DeductOrgUserCreditReturn {
  ok: boolean  
}
export interface DeductFakeResourceCostArgs {
  org_id: number
  user_id: number
  cent: number
}

export interface DeductFakeResourceCostReturn {
  ok: boolean  
}
export interface TestDeductCreditArgs {
}

export interface TestDeductCreditReturn {
  ok: boolean  
}
export interface SetUpNewOrgArgs {
  request: SetUpNewOrg
}

export interface SetUpNewOrgReturn {
  org_id: number  
}
export interface KubeConfDetailsArgs {
}

export interface KubeConfDetailsReturn {
  items: Array<KubeConfInstanceType>  
}


  
//
// Client
//
export class Inference implements Inference {
  protected hostname: string
  protected fetch: Fetch
  protected path = '/rpc/Inference/'

  constructor(hostname: string, fetch: Fetch) {
    this.hostname = hostname.replace(/\/*$/, '')
    this.fetch = (input: RequestInfo, init?: RequestInit) => fetch(input, init)
  }

  private url(name: string): string {
    return this.hostname + this.path + name
  }
  
  requestOTP = (args: RequestOTPArgs, headers?: object, signal?: AbortSignal): Promise<RequestOTPReturn> => {
    return this.fetch(
      this.url('RequestOTP'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  login = (args: LoginArgs, headers?: object, signal?: AbortSignal): Promise<LoginReturn> => {
    return this.fetch(
      this.url('Login'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          token: <string>(_data.token),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  storageBackupCallback = (args: StorageBackupCallbackArgs, headers?: object, signal?: AbortSignal): Promise<StorageBackupCallbackReturn> => {
    return this.fetch(
      this.url('StorageBackupCallback'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  createOrgInvite = (args: CreateOrgInviteArgs, headers?: object, signal?: AbortSignal): Promise<CreateOrgInviteReturn> => {
    return this.fetch(
      this.url('CreateOrgInvite'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  createOrgInviteBatch = (args: CreateOrgInviteBatchArgs, headers?: object, signal?: AbortSignal): Promise<CreateOrgInviteBatchReturn> => {
    return this.fetch(
      this.url('CreateOrgInviteBatch'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  createOrg = (args: CreateOrgArgs, headers?: object, signal?: AbortSignal): Promise<CreateOrgReturn> => {
    return this.fetch(
      this.url('CreateOrg'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          org_id: <number>(_data.org_id),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getUserOrgs = (headers?: object, signal?: AbortSignal): Promise<GetUserOrgsReturn> => {
    return this.fetch(
      this.url('GetUserOrgs'),
      createHTTPRequest({}, headers, signal)
      ).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          orgs: <Array<UserOrg>>(_data.orgs),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgUsers = (args: GetOrgUsersArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgUsersReturn> => {
    return this.fetch(
      this.url('GetOrgUsers'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          users: <Array<UserOrganization>>(_data.users),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrg = (headers?: object, signal?: AbortSignal): Promise<GetOrgReturn> => {
    return this.fetch(
      this.url('GetOrg'),
      createHTTPRequest({}, headers, signal)
      ).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          org: <Organization>(_data.org),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  updateOrgUser = (args: UpdateOrgUserArgs, headers?: object, signal?: AbortSignal): Promise<UpdateOrgUserReturn> => {
    return this.fetch(
      this.url('UpdateOrgUser'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  deleteOrgUser = (args: DeleteOrgUserArgs, headers?: object, signal?: AbortSignal): Promise<DeleteOrgUserReturn> => {
    return this.fetch(
      this.url('DeleteOrgUser'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  updateOrgUserProfileV2 = (args: UpdateOrgUserProfileV2Args, headers?: object, signal?: AbortSignal): Promise<UpdateOrgUserProfileV2Return> => {
    return this.fetch(
      this.url('UpdateOrgUserProfileV2'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  updateOrgProfile = (args: UpdateOrgProfileArgs, headers?: object, signal?: AbortSignal): Promise<UpdateOrgProfileReturn> => {
    return this.fetch(
      this.url('UpdateOrgProfile'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgMetric = (args: GetOrgMetricArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgMetricReturn> => {
    return this.fetch(
      this.url('GetOrgMetric'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          metric: <OrganizationMetricData>(_data.metric),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgGraph = (args: GetOrgGraphArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgGraphReturn> => {
    return this.fetch(
      this.url('GetOrgGraph'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          graph: <GetOrgGraphData>(_data.graph),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgUsageGraph = (args: GetOrgUsageGraphArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgUsageGraphReturn> => {
    return this.fetch(
      this.url('GetOrgUsageGraph'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          items: <Array<GetOrgUsageGraphDataItem>>(_data.items),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgUserGraph = (args: GetOrgUserGraphArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgUserGraphReturn> => {
    return this.fetch(
      this.url('GetOrgUserGraph'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          items: <Array<GetOrgUserMetricItem>>(_data.items),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgServerAnalytics = (args: GetOrgServerAnalyticsArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgServerAnalyticsReturn> => {
    return this.fetch(
      this.url('GetOrgServerAnalytics'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          items: <Array<GetOrgServerAnalyticsDataItem>>(_data.items),
          total_duration_seconds: <number>(_data.total_duration_seconds),
          total_spent: <number>(_data.total_spent),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgStorageAnalytics = (args: GetOrgStorageAnalyticsArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgStorageAnalyticsReturn> => {
    return this.fetch(
      this.url('GetOrgStorageAnalytics'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          items: <Array<GetOrgStorageAnalyticsDataItem>>(_data.items),
          total_duration_seconds: <number>(_data.total_duration_seconds),
          total_spent: <number>(_data.total_spent),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgBalanceSummary = (headers?: object, signal?: AbortSignal): Promise<GetOrgBalanceSummaryReturn> => {
    return this.fetch(
      this.url('GetOrgBalanceSummary'),
      createHTTPRequest({}, headers, signal)
      ).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          summary: <GetOrgBalanceSummaryData>(_data.summary),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgUserBalanceSummary = (headers?: object, signal?: AbortSignal): Promise<GetOrgUserBalanceSummaryReturn> => {
    return this.fetch(
      this.url('GetOrgUserBalanceSummary'),
      createHTTPRequest({}, headers, signal)
      ).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          summary: <GetOrgUserBalanceSummaryData>(_data.summary),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgSpendRate = (headers?: object, signal?: AbortSignal): Promise<GetOrgSpendRateReturn> => {
    return this.fetch(
      this.url('GetOrgSpendRate'),
      createHTTPRequest({}, headers, signal)
      ).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          summary: <GetSpentBalanceSummaryData>(_data.summary),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgUserSpendRate = (headers?: object, signal?: AbortSignal): Promise<GetOrgUserSpendRateReturn> => {
    return this.fetch(
      this.url('GetOrgUserSpendRate'),
      createHTTPRequest({}, headers, signal)
      ).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          summary: <GetSpentBalanceSummaryData>(_data.summary),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getAuditLogs = (args: GetAuditLogsArgs, headers?: object, signal?: AbortSignal): Promise<GetAuditLogsReturn> => {
    return this.fetch(
      this.url('GetAuditLogs'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          items: <Array<AuditLog>>(_data.items),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgCreditAnalytics = (args: GetOrgCreditAnalyticsArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgCreditAnalyticsReturn> => {
    return this.fetch(
      this.url('GetOrgCreditAnalytics'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          items: <Array<GetOrgCreditAnalyticsData>>(_data.items),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  createOrgSpendingLimit = (args: CreateOrgSpendingLimitArgs, headers?: object, signal?: AbortSignal): Promise<CreateOrgSpendingLimitReturn> => {
    return this.fetch(
      this.url('CreateOrgSpendingLimit'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgSpendingLimit = (headers?: object, signal?: AbortSignal): Promise<GetOrgSpendingLimitReturn> => {
    return this.fetch(
      this.url('GetOrgSpendingLimit'),
      createHTTPRequest({}, headers, signal)
      ).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          spending_limit: <SpendingLimit>(_data.spending_limit),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  createOrgUserSpendingLimit = (args: CreateOrgUserSpendingLimitArgs, headers?: object, signal?: AbortSignal): Promise<CreateOrgUserSpendingLimitReturn> => {
    return this.fetch(
      this.url('CreateOrgUserSpendingLimit'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  resetOrgUserSpendingLimit = (args: ResetOrgUserSpendingLimitArgs, headers?: object, signal?: AbortSignal): Promise<ResetOrgUserSpendingLimitReturn> => {
    return this.fetch(
      this.url('ResetOrgUserSpendingLimit'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgUserSpendingLimit = (args: GetOrgUserSpendingLimitArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgUserSpendingLimitReturn> => {
    return this.fetch(
      this.url('GetOrgUserSpendingLimit'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          spending_limit: <SpendingLimit>(_data.spending_limit),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgUsersSpendingLimit = (args: GetOrgUsersSpendingLimitArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgUsersSpendingLimitReturn> => {
    return this.fetch(
      this.url('GetOrgUsersSpendingLimit'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          spending_limits: <Array<SpendingLimit>>(_data.spending_limits),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  createSpendingLimitAutomation = (args: CreateSpendingLimitAutomationArgs, headers?: object, signal?: AbortSignal): Promise<CreateSpendingLimitAutomationReturn> => {
    return this.fetch(
      this.url('CreateSpendingLimitAutomation'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  deleteSpendingLimitAutomation = (args: DeleteSpendingLimitAutomationArgs, headers?: object, signal?: AbortSignal): Promise<DeleteSpendingLimitAutomationReturn> => {
    return this.fetch(
      this.url('DeleteSpendingLimitAutomation'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getSpendingLimitAutomation = (args: GetSpendingLimitAutomationArgs, headers?: object, signal?: AbortSignal): Promise<GetSpendingLimitAutomationReturn> => {
    return this.fetch(
      this.url('GetSpendingLimitAutomation'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          data: <SpendingLimitAutomation>(_data.data),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  listSpendingLimitAutomations = (args: ListSpendingLimitAutomationsArgs, headers?: object, signal?: AbortSignal): Promise<ListSpendingLimitAutomationsReturn> => {
    return this.fetch(
      this.url('ListSpendingLimitAutomations'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          automations: <Array<SpendingLimitAutomation>>(_data.automations),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgUserLimit = (args: GetOrgUserLimitArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgUserLimitReturn> => {
    return this.fetch(
      this.url('GetOrgUserLimit'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          limit: <UserLimit>(_data.limit),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgUsersLimit = (args: GetOrgUsersLimitArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgUsersLimitReturn> => {
    return this.fetch(
      this.url('GetOrgUsersLimit'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          limits: <Array<UsersLimitsReturn>>(_data.limits),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgLimit = (headers?: object, signal?: AbortSignal): Promise<GetOrgLimitReturn> => {
    return this.fetch(
      this.url('GetOrgLimit'),
      createHTTPRequest({}, headers, signal)
      ).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          limit: <OrganizationMetadataLimit>(_data.limit),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  updateOrgUserLimit = (args: UpdateOrgUserLimitArgs, headers?: object, signal?: AbortSignal): Promise<UpdateOrgUserLimitReturn> => {
    return this.fetch(
      this.url('UpdateOrgUserLimit'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  resetOrgUserLimit = (args: ResetOrgUserLimitArgs, headers?: object, signal?: AbortSignal): Promise<ResetOrgUserLimitReturn> => {
    return this.fetch(
      this.url('ResetOrgUserLimit'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  updateOrgLimit = (args: UpdateOrgLimitArgs, headers?: object, signal?: AbortSignal): Promise<UpdateOrgLimitReturn> => {
    return this.fetch(
      this.url('UpdateOrgLimit'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  createOrgPayment = (args: CreateOrgPaymentArgs, headers?: object, signal?: AbortSignal): Promise<CreateOrgPaymentReturn> => {
    return this.fetch(
      this.url('CreateOrgPayment'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          url: <string>(_data.url),
          id: <string>(_data.id),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  createOrgUserPayment = (args: CreateOrgUserPaymentArgs, headers?: object, signal?: AbortSignal): Promise<CreateOrgUserPaymentReturn> => {
    return this.fetch(
      this.url('CreateOrgUserPayment'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          url: <string>(_data.url),
          id: <string>(_data.id),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgInvoices = (args: GetOrgInvoicesArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgInvoicesReturn> => {
    return this.fetch(
      this.url('GetOrgInvoices'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          items: <Array<Invoice>>(_data.items),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getOrgUserInvoices = (args: GetOrgUserInvoicesArgs, headers?: object, signal?: AbortSignal): Promise<GetOrgUserInvoicesReturn> => {
    return this.fetch(
      this.url('GetOrgUserInvoices'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          items: <Array<Invoice>>(_data.items),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  createSSHKey = (args: CreateSSHKeyArgs, headers?: object, signal?: AbortSignal): Promise<CreateSSHKeyReturn> => {
    return this.fetch(
      this.url('CreateSSHKey'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  listSSHKeys = (args: ListSSHKeysArgs, headers?: object, signal?: AbortSignal): Promise<ListSSHKeysReturn> => {
    return this.fetch(
      this.url('ListSSHKeys'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          keys: <Array<UserSSHKey>>(_data.keys),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  deleteSSHKey = (args: DeleteSSHKeyArgs, headers?: object, signal?: AbortSignal): Promise<DeleteSSHKeyReturn> => {
    return this.fetch(
      this.url('DeleteSSHKey'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  createStorageVolume = (args: CreateStorageVolumeArgs, headers?: object, signal?: AbortSignal): Promise<CreateStorageVolumeReturn> => {
    return this.fetch(
      this.url('CreateStorageVolume'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  listStorageVolumes = (args: ListStorageVolumesArgs, headers?: object, signal?: AbortSignal): Promise<ListStorageVolumesReturn> => {
    return this.fetch(
      this.url('ListStorageVolumes'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          volumes: <Array<ListStorageVolumeDataItem>>(_data.volumes),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  deleteStorageVolume = (args: DeleteStorageVolumeArgs, headers?: object, signal?: AbortSignal): Promise<DeleteStorageVolumeReturn> => {
    return this.fetch(
      this.url('DeleteStorageVolume'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getStorageVolumeInfo = (args: GetStorageVolumeInfoArgs, headers?: object, signal?: AbortSignal): Promise<GetStorageVolumeInfoReturn> => {
    return this.fetch(
      this.url('GetStorageVolumeInfo'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          volume: <StorageVolume>(_data.volume),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  syncStorageGoogleDrive = (args: SyncStorageGoogleDriveArgs, headers?: object, signal?: AbortSignal): Promise<SyncStorageGoogleDriveReturn> => {
    return this.fetch(
      this.url('SyncStorageGoogleDrive'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  updateStorageVolume = (args: UpdateStorageVolumeArgs, headers?: object, signal?: AbortSignal): Promise<UpdateStorageVolumeReturn> => {
    return this.fetch(
      this.url('UpdateStorageVolume'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  createGoogleDriveToken = (args: CreateGoogleDriveTokenArgs, headers?: object, signal?: AbortSignal): Promise<CreateGoogleDriveTokenReturn> => {
    return this.fetch(
      this.url('CreateGoogleDriveToken'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          token: <string>(_data.token),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  deleteGoogleDriveToken = (args: DeleteGoogleDriveTokenArgs, headers?: object, signal?: AbortSignal): Promise<DeleteGoogleDriveTokenReturn> => {
    return this.fetch(
      this.url('DeleteGoogleDriveToken'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  listGoogleDriveTokens = (args: ListGoogleDriveTokensArgs, headers?: object, signal?: AbortSignal): Promise<ListGoogleDriveTokensReturn> => {
    return this.fetch(
      this.url('ListGoogleDriveTokens'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          items: <Array<GoogleDriveToken>>(_data.items),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  addGoogleDrive = (args: AddGoogleDriveArgs, headers?: object, signal?: AbortSignal): Promise<AddGoogleDriveReturn> => {
    return this.fetch(
      this.url('AddGoogleDrive'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          item: <GoogleDrive>(_data.item),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  deleteGoogleDrive = (args: DeleteGoogleDriveArgs, headers?: object, signal?: AbortSignal): Promise<DeleteGoogleDriveReturn> => {
    return this.fetch(
      this.url('DeleteGoogleDrive'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  listGoogleDrive = (args: ListGoogleDriveArgs, headers?: object, signal?: AbortSignal): Promise<ListGoogleDriveReturn> => {
    return this.fetch(
      this.url('ListGoogleDrive'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          items: <Array<GoogleDrive>>(_data.items),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  createStorageBackup = (args: CreateStorageBackupArgs, headers?: object, signal?: AbortSignal): Promise<CreateStorageBackupReturn> => {
    return this.fetch(
      this.url('CreateStorageBackup'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          item: <StorageVolumeBackup>(_data.item),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  restoreStorageBackup = (args: RestoreStorageBackupArgs, headers?: object, signal?: AbortSignal): Promise<RestoreStorageBackupReturn> => {
    return this.fetch(
      this.url('RestoreStorageBackup'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  createServerTemplate = (args: CreateServerTemplateArgs, headers?: object, signal?: AbortSignal): Promise<CreateServerTemplateReturn> => {
    return this.fetch(
      this.url('CreateServerTemplate'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  updateServerTemplate = (args: UpdateServerTemplateArgs, headers?: object, signal?: AbortSignal): Promise<UpdateServerTemplateReturn> => {
    return this.fetch(
      this.url('UpdateServerTemplate'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  listServerTemplates = (args: ListServerTemplatesArgs, headers?: object, signal?: AbortSignal): Promise<ListServerTemplatesReturn> => {
    return this.fetch(
      this.url('ListServerTemplates'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          templates: <Array<TemplateResponseData>>(_data.templates),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  deleteServerTemplate = (args: DeleteServerTemplateArgs, headers?: object, signal?: AbortSignal): Promise<DeleteServerTemplateReturn> => {
    return this.fetch(
      this.url('DeleteServerTemplate'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getServerTemplate = (args: GetServerTemplateArgs, headers?: object, signal?: AbortSignal): Promise<GetServerTemplateReturn> => {
    return this.fetch(
      this.url('GetServerTemplate'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          template: <TemplateResponseData>(_data.template),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getServerTemplatePrice = (args: GetServerTemplatePriceArgs, headers?: object, signal?: AbortSignal): Promise<GetServerTemplatePriceReturn> => {
    return this.fetch(
      this.url('GetServerTemplatePrice'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          price: <ResourcePricing>(_data.price),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  listPublicServerTemplates = (args: ListPublicServerTemplatesArgs, headers?: object, signal?: AbortSignal): Promise<ListPublicServerTemplatesReturn> => {
    return this.fetch(
      this.url('ListPublicServerTemplates'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          templates: <Array<TemplateResponseData>>(_data.templates),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  createServerInstance = (args: CreateServerInstanceArgs, headers?: object, signal?: AbortSignal): Promise<CreateServerInstanceReturn> => {
    return this.fetch(
      this.url('CreateServerInstance'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          instance_id: <number>(_data.instance_id),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  listServerInstances = (args: ListServerInstancesArgs, headers?: object, signal?: AbortSignal): Promise<ListServerInstancesReturn> => {
    return this.fetch(
      this.url('ListServerInstances'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          instances: <Array<ListServerInstanceItem>>(_data.instances),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  deleteServerInstance = (args: DeleteServerInstanceArgs, headers?: object, signal?: AbortSignal): Promise<DeleteServerInstanceReturn> => {
    return this.fetch(
      this.url('DeleteServerInstance'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getServerInstance = (args: GetServerInstanceArgs, headers?: object, signal?: AbortSignal): Promise<GetServerInstanceReturn> => {
    return this.fetch(
      this.url('GetServerInstance'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          instance: <GetServerInstanceData>(_data.instance),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  updateServerInstance = (args: UpdateServerInstanceArgs, headers?: object, signal?: AbortSignal): Promise<UpdateServerInstanceReturn> => {
    return this.fetch(
      this.url('UpdateServerInstance'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getServerInstanceMetrics = (args: GetServerInstanceMetricsArgs, headers?: object, signal?: AbortSignal): Promise<GetServerInstanceMetricsReturn> => {
    return this.fetch(
      this.url('GetServerInstanceMetrics'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          metrics: <Array<ServerInstanceMetrics>>(_data.metrics),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getServerInstancePodName = (args: GetServerInstancePodNameArgs, headers?: object, signal?: AbortSignal): Promise<GetServerInstancePodNameReturn> => {
    return this.fetch(
      this.url('GetServerInstancePodName'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          pod_name: <Array<string>>(_data.pod_name),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getServerWebSSHSession = (args: GetServerWebSSHSessionArgs, headers?: object, signal?: AbortSignal): Promise<GetServerWebSSHSessionReturn> => {
    return this.fetch(
      this.url('GetServerWebSSHSession'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          url: <string>(_data.url),
          pid: <number>(_data.pid),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  updateServerInstanceScaleConfig = (args: UpdateServerInstanceScaleConfigArgs, headers?: object, signal?: AbortSignal): Promise<UpdateServerInstanceScaleConfigReturn> => {
    return this.fetch(
      this.url('UpdateServerInstanceScaleConfig'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getServerInstanceScaleHistory = (args: GetServerInstanceScaleHistoryArgs, headers?: object, signal?: AbortSignal): Promise<GetServerInstanceScaleHistoryReturn> => {
    return this.fetch(
      this.url('GetServerInstanceScaleHistory'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          items: <Array<InstanceScaleHistoryItem>>(_data.items),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  mountStorage = (args: MountStorageArgs, headers?: object, signal?: AbortSignal): Promise<MountStorageReturn> => {
    return this.fetch(
      this.url('MountStorage'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  setAutoShutdown = (args: SetAutoShutdownArgs, headers?: object, signal?: AbortSignal): Promise<SetAutoShutdownReturn> => {
    return this.fetch(
      this.url('SetAutoShutdown'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  listNotifications = (args: ListNotificationsArgs, headers?: object, signal?: AbortSignal): Promise<ListNotificationsReturn> => {
    return this.fetch(
      this.url('ListNotifications'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          notifications: <Array<Notification>>(_data.notifications),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  markNotificationRead = (args: MarkNotificationReadArgs, headers?: object, signal?: AbortSignal): Promise<MarkNotificationReadReturn> => {
    return this.fetch(
      this.url('MarkNotificationRead'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  createAPIKey = (args: CreateAPIKeyArgs, headers?: object, signal?: AbortSignal): Promise<CreateAPIKeyReturn> => {
    return this.fetch(
      this.url('CreateAPIKey'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          api_key: <string>(_data.api_key),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  listAPIKeys = (headers?: object, signal?: AbortSignal): Promise<ListAPIKeysReturn> => {
    return this.fetch(
      this.url('ListAPIKeys'),
      createHTTPRequest({}, headers, signal)
      ).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          api_keys: <Array<APIKey>>(_data.api_keys),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  deleteAPIKey = (args: DeleteAPIKeyArgs, headers?: object, signal?: AbortSignal): Promise<DeleteAPIKeyReturn> => {
    return this.fetch(
      this.url('DeleteAPIKey'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  createDockerCred = (args: CreateDockerCredArgs, headers?: object, signal?: AbortSignal): Promise<CreateDockerCredReturn> => {
    return this.fetch(
      this.url('CreateDockerCred'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  listDockerCreds = (args: ListDockerCredsArgs, headers?: object, signal?: AbortSignal): Promise<ListDockerCredsReturn> => {
    return this.fetch(
      this.url('ListDockerCreds'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          creds: <Array<DockerCred>>(_data.creds),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  deleteDockerCred = (args: DeleteDockerCredArgs, headers?: object, signal?: AbortSignal): Promise<DeleteDockerCredReturn> => {
    return this.fetch(
      this.url('DeleteDockerCred'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
}
export class InferenceExternal implements InferenceExternal {
  protected hostname: string
  protected fetch: Fetch
  protected path = '/rpc/InferenceExternal/'

  constructor(hostname: string, fetch: Fetch) {
    this.hostname = hostname.replace(/\/*$/, '')
    this.fetch = (input: RequestInfo, init?: RequestInit) => fetch(input, init)
  }

  private url(name: string): string {
    return this.hostname + this.path + name
  }
  
  externalListServerInstances = (args: ExternalListServerInstancesArgs, headers?: object, signal?: AbortSignal): Promise<ExternalListServerInstancesReturn> => {
    return this.fetch(
      this.url('ExternalListServerInstances'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          instances: <Array<ListServerInstanceItem>>(_data.instances),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  externalCreateServerInstance = (args: ExternalCreateServerInstanceArgs, headers?: object, signal?: AbortSignal): Promise<ExternalCreateServerInstanceReturn> => {
    return this.fetch(
      this.url('ExternalCreateServerInstance'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  externalDeleteServerInstance = (args: ExternalDeleteServerInstanceArgs, headers?: object, signal?: AbortSignal): Promise<ExternalDeleteServerInstanceReturn> => {
    return this.fetch(
      this.url('ExternalDeleteServerInstance'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  externalListServerTemplates = (args: ExternalListServerTemplatesArgs, headers?: object, signal?: AbortSignal): Promise<ExternalListServerTemplatesReturn> => {
    return this.fetch(
      this.url('ExternalListServerTemplates'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          templates: <Array<TemplateResponseData>>(_data.templates),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  externalListStorageVolumes = (args: ExternalListStorageVolumesArgs, headers?: object, signal?: AbortSignal): Promise<ExternalListStorageVolumesReturn> => {
    return this.fetch(
      this.url('ExternalListStorageVolumes'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          volumes: <Array<ListStorageVolumeDataItem>>(_data.volumes),
          total: <number>(_data.total),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
}
export class InferenceInternal implements InferenceInternal {
  protected hostname: string
  protected fetch: Fetch
  protected path = '/rpc/InferenceInternal/'

  constructor(hostname: string, fetch: Fetch) {
    this.hostname = hostname.replace(/\/*$/, '')
    this.fetch = (input: RequestInfo, init?: RequestInit) => fetch(input, init)
  }

  private url(name: string): string {
    return this.hostname + this.path + name
  }
  
  createOrg = (args: CreateOrgArgs, headers?: object, signal?: AbortSignal): Promise<CreateOrgReturn> => {
    return this.fetch(
      this.url('CreateOrg'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          org_id: <number>(_data.org_id),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  createUser = (args: CreateUserArgs, headers?: object, signal?: AbortSignal): Promise<CreateUserReturn> => {
    return this.fetch(
      this.url('CreateUser'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          user_id: <number>(_data.user_id),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  getUser = (args: GetUserArgs, headers?: object, signal?: AbortSignal): Promise<GetUserReturn> => {
    return this.fetch(
      this.url('GetUser'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          user_orgs: <Array<UserOrg>>(_data.user_orgs),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  setOrgUser = (args: SetOrgUserArgs, headers?: object, signal?: AbortSignal): Promise<SetOrgUserReturn> => {
    return this.fetch(
      this.url('SetOrgUser'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  addOrgCredit = (args: AddOrgCreditArgs, headers?: object, signal?: AbortSignal): Promise<AddOrgCreditReturn> => {
    return this.fetch(
      this.url('AddOrgCredit'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  setOrgLimit = (args: SetOrgLimitArgs, headers?: object, signal?: AbortSignal): Promise<SetOrgLimitReturn> => {
    return this.fetch(
      this.url('SetOrgLimit'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  addKubeConfig = (args: AddKubeConfigArgs, headers?: object, signal?: AbortSignal): Promise<AddKubeConfigReturn> => {
    return this.fetch(
      this.url('AddKubeConfig'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  deductOrgCredit = (args: DeductOrgCreditArgs, headers?: object, signal?: AbortSignal): Promise<DeductOrgCreditReturn> => {
    return this.fetch(
      this.url('DeductOrgCredit'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  deductOrgUserCredit = (args: DeductOrgUserCreditArgs, headers?: object, signal?: AbortSignal): Promise<DeductOrgUserCreditReturn> => {
    return this.fetch(
      this.url('DeductOrgUserCredit'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  deductFakeResourceCost = (args: DeductFakeResourceCostArgs, headers?: object, signal?: AbortSignal): Promise<DeductFakeResourceCostReturn> => {
    return this.fetch(
      this.url('DeductFakeResourceCost'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  testDeductCredit = (headers?: object, signal?: AbortSignal): Promise<TestDeductCreditReturn> => {
    return this.fetch(
      this.url('TestDeductCredit'),
      createHTTPRequest({}, headers, signal)
      ).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          ok: <boolean>(_data.ok),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  setUpNewOrg = (args: SetUpNewOrgArgs, headers?: object, signal?: AbortSignal): Promise<SetUpNewOrgReturn> => {
    return this.fetch(
      this.url('SetUpNewOrg'),
      createHTTPRequest(args, headers, signal)).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          org_id: <number>(_data.org_id),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
  kubeConfDetails = (headers?: object, signal?: AbortSignal): Promise<KubeConfDetailsReturn> => {
    return this.fetch(
      this.url('KubeConfDetails'),
      createHTTPRequest({}, headers, signal)
      ).then((res) => {
      return buildResponse(res).then(_data => {
        return {
          items: <Array<KubeConfInstanceType>>(_data.items),
        }
      })
    }, (error) => {
      throw WebrpcRequestFailedError.new({ cause: `fetch(): ${error.message || ''}` })
    })
  }
  
}

  const createHTTPRequest = (body: object = {}, headers: object = {}, signal: AbortSignal | null = null): object => {
  const reqHeaders: {[key: string]: string} = { ...headers, 'Content-Type': 'application/json' }
  reqHeaders[WebrpcHeader] = WebrpcHeaderValue

  return {
    method: 'POST',
    headers: reqHeaders,
    body: JSON.stringify(body || {}),
    signal
  }
}

const buildResponse = (res: Response): Promise<any> => {
  return res.text().then(text => {
    let data
    try {
      data = JSON.parse(text)
    } catch(error) {
      let message = ''
      if (error instanceof Error)  {
        message = error.message
      }
      throw WebrpcBadResponseError.new({
        status: res.status,
        cause: `JSON.parse(): ${message}: response text: ${text}`},
      )
    }
    if (!res.ok) {
      const code: number = (typeof data.code === 'number') ? data.code : 0
      throw (webrpcErrorByCode[code] || WebrpcError).new(data)
    }
    return data
  })
}

//
// Errors
//

export class WebrpcError extends Error {
  name: string
  code: number
  message: string
  status: number
  cause?: string

  /** @deprecated Use message instead of msg. Deprecated in webrpc v0.11.0. */
  msg: string

  constructor(name: string, code: number, message: string, status: number, cause?: string) {
    super(message)
    this.name = name || 'WebrpcError'
    this.code = typeof code === 'number' ? code : 0
    this.message = message || `endpoint error ${this.code}`
    this.msg = this.message
    this.status = typeof status === 'number' ? status : 0
    this.cause = cause
    Object.setPrototypeOf(this, WebrpcError.prototype)
  }

  static new(payload: any): WebrpcError {
    return new this(payload.error, payload.code, payload.message || payload.msg, payload.status, payload.cause)
  }
}

// Webrpc errors

export class WebrpcEndpointError extends WebrpcError {
  constructor(
    name: string = 'WebrpcEndpoint',
    code: number = 0,
    message: string = `endpoint error`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, WebrpcEndpointError.prototype)
  }
}

export class WebrpcRequestFailedError extends WebrpcError {
  constructor(
    name: string = 'WebrpcRequestFailed',
    code: number = -1,
    message: string = `request failed`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, WebrpcRequestFailedError.prototype)
  }
}

export class WebrpcBadRouteError extends WebrpcError {
  constructor(
    name: string = 'WebrpcBadRoute',
    code: number = -2,
    message: string = `bad route`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, WebrpcBadRouteError.prototype)
  }
}

export class WebrpcBadMethodError extends WebrpcError {
  constructor(
    name: string = 'WebrpcBadMethod',
    code: number = -3,
    message: string = `bad method`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, WebrpcBadMethodError.prototype)
  }
}

export class WebrpcBadRequestError extends WebrpcError {
  constructor(
    name: string = 'WebrpcBadRequest',
    code: number = -4,
    message: string = `bad request`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, WebrpcBadRequestError.prototype)
  }
}

export class WebrpcBadResponseError extends WebrpcError {
  constructor(
    name: string = 'WebrpcBadResponse',
    code: number = -5,
    message: string = `bad response`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, WebrpcBadResponseError.prototype)
  }
}

export class WebrpcServerPanicError extends WebrpcError {
  constructor(
    name: string = 'WebrpcServerPanic',
    code: number = -6,
    message: string = `server panic`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, WebrpcServerPanicError.prototype)
  }
}

export class WebrpcInternalErrorError extends WebrpcError {
  constructor(
    name: string = 'WebrpcInternalError',
    code: number = -7,
    message: string = `internal error`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, WebrpcInternalErrorError.prototype)
  }
}

export class WebrpcClientDisconnectedError extends WebrpcError {
  constructor(
    name: string = 'WebrpcClientDisconnected',
    code: number = -8,
    message: string = `client disconnected`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, WebrpcClientDisconnectedError.prototype)
  }
}

export class WebrpcStreamLostError extends WebrpcError {
  constructor(
    name: string = 'WebrpcStreamLost',
    code: number = -9,
    message: string = `stream lost`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, WebrpcStreamLostError.prototype)
  }
}

export class WebrpcStreamFinishedError extends WebrpcError {
  constructor(
    name: string = 'WebrpcStreamFinished',
    code: number = -10,
    message: string = `stream finished`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, WebrpcStreamFinishedError.prototype)
  }
}


// Schema errors

export class UnauthorizedError extends WebrpcError {
  constructor(
    name: string = 'Unauthorized',
    code: number = 100,
    message: string = `You are not authorized to perform this action`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, UnauthorizedError.prototype)
  }
}

export class ForbiddenError extends WebrpcError {
  constructor(
    name: string = 'Forbidden',
    code: number = 101,
    message: string = `You are not allowed to perform this action`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, ForbiddenError.prototype)
  }
}

export class NotInOrgError extends WebrpcError {
  constructor(
    name: string = 'NotInOrg',
    code: number = 102,
    message: string = `You are not part of this organization`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, NotInOrgError.prototype)
  }
}

export class NotOrgAdminError extends WebrpcError {
  constructor(
    name: string = 'NotOrgAdmin',
    code: number = 103,
    message: string = `You are not an organization admin`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, NotOrgAdminError.prototype)
  }
}

export class InsufficientCreditError extends WebrpcError {
  constructor(
    name: string = 'InsufficientCredit',
    code: number = 104,
    message: string = `You have insufficient credit for performing this action`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, InsufficientCreditError.prototype)
  }
}

export class ValidationFailedError extends WebrpcError {
  constructor(
    name: string = 'ValidationFailed',
    code: number = 105,
    message: string = `The data provided is invalid, please check the data and try again`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, ValidationFailedError.prototype)
  }
}

export class ResourceNotFoundError extends WebrpcError {
  constructor(
    name: string = 'ResourceNotFound',
    code: number = 106,
    message: string = `The resource you are looking for does not exist`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, ResourceNotFoundError.prototype)
  }
}

export class InternalServerErrorError extends WebrpcError {
  constructor(
    name: string = 'InternalServerError',
    code: number = 107,
    message: string = `We encountered an internal error. Our team has been notified.`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, InternalServerErrorError.prototype)
  }
}

export class ServiceErrorError extends WebrpcError {
  constructor(
    name: string = 'ServiceError',
    code: number = 108,
    message: string = `Could not complete the request`,
    status: number = 0,
    cause?: string
  ) {
    super(name, code, message, status, cause)
    Object.setPrototypeOf(this, ServiceErrorError.prototype)
  }
}


export enum errors {
  WebrpcEndpoint = 'WebrpcEndpoint',
  WebrpcRequestFailed = 'WebrpcRequestFailed',
  WebrpcBadRoute = 'WebrpcBadRoute',
  WebrpcBadMethod = 'WebrpcBadMethod',
  WebrpcBadRequest = 'WebrpcBadRequest',
  WebrpcBadResponse = 'WebrpcBadResponse',
  WebrpcServerPanic = 'WebrpcServerPanic',
  WebrpcInternalError = 'WebrpcInternalError',
  WebrpcClientDisconnected = 'WebrpcClientDisconnected',
  WebrpcStreamLost = 'WebrpcStreamLost',
  WebrpcStreamFinished = 'WebrpcStreamFinished',
  Unauthorized = 'Unauthorized',
  Forbidden = 'Forbidden',
  NotInOrg = 'NotInOrg',
  NotOrgAdmin = 'NotOrgAdmin',
  InsufficientCredit = 'InsufficientCredit',
  ValidationFailed = 'ValidationFailed',
  ResourceNotFound = 'ResourceNotFound',
  InternalServerError = 'InternalServerError',
  ServiceError = 'ServiceError',
}

export enum WebrpcErrorCodes {
  WebrpcEndpoint = 0,
  WebrpcRequestFailed = -1,
  WebrpcBadRoute = -2,
  WebrpcBadMethod = -3,
  WebrpcBadRequest = -4,
  WebrpcBadResponse = -5,
  WebrpcServerPanic = -6,
  WebrpcInternalError = -7,
  WebrpcClientDisconnected = -8,
  WebrpcStreamLost = -9,
  WebrpcStreamFinished = -10,
  Unauthorized = 100,
  Forbidden = 101,
  NotInOrg = 102,
  NotOrgAdmin = 103,
  InsufficientCredit = 104,
  ValidationFailed = 105,
  ResourceNotFound = 106,
  InternalServerError = 107,
  ServiceError = 108,
}

export const webrpcErrorByCode: { [code: number]: any } = {
  [0]: WebrpcEndpointError,
  [-1]: WebrpcRequestFailedError,
  [-2]: WebrpcBadRouteError,
  [-3]: WebrpcBadMethodError,
  [-4]: WebrpcBadRequestError,
  [-5]: WebrpcBadResponseError,
  [-6]: WebrpcServerPanicError,
  [-7]: WebrpcInternalErrorError,
  [-8]: WebrpcClientDisconnectedError,
  [-9]: WebrpcStreamLostError,
  [-10]: WebrpcStreamFinishedError,
  [100]: UnauthorizedError,
  [101]: ForbiddenError,
  [102]: NotInOrgError,
  [103]: NotOrgAdminError,
  [104]: InsufficientCreditError,
  [105]: ValidationFailedError,
  [106]: ResourceNotFoundError,
  [107]: InternalServerErrorError,
  [108]: ServiceErrorError,
}

export type Fetch = (input: RequestInfo, init?: RequestInit) => Promise<Response>

